/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PayoutOrganizerDto { 
    /**
     * User ID
     */
    userId: string;
    /**
     * Email address
     */
    email: string;
    /**
     * First name
     */
    firstName: string;
    /**
     * Last name
     */
    lastName: string;
    /**
     * Display name
     */
    displayName?: string;
    /**
     * Avatar URL
     */
    avatarUrl?: string;
    /**
     * Stripe Connected Account ID
     */
    connectedAccountId?: string;
    /**
     * Connected Account status
     */
    connectedAccountStatus: PayoutOrganizerDto.ConnectedAccountStatusEnum;
    /**
     * Current available balance in cents
     */
    currentBalance: number;
    /**
     * Current escrow balance in cents
     */
    escrowBalance: number;
    /**
     * Total earnings in cents
     */
    totalEarned: number;
    /**
     * Total payouts in cents
     */
    totalPayouts: number;
}
export namespace PayoutOrganizerDto {
    export type ConnectedAccountStatusEnum = 'complete' | 'incomplete' | 'not_started';
    export const ConnectedAccountStatusEnum = {
        Complete: 'complete' as ConnectedAccountStatusEnum,
        Incomplete: 'incomplete' as ConnectedAccountStatusEnum,
        NotStarted: 'not_started' as ConnectedAccountStatusEnum
    };
}


